import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { DailyLessonLockIcon } from '../atoms/icons/daily_lesson_lock_icon';
import { HomeDailyLessonPopoverArrowIcon } from '../atoms/icons/home_daily_lesson_popover_arrow_icon';
import { Colors } from '../styles/variables';
export const HomeDailyLessonFuturePopover = ({ top, left, arrowLeft, isClosing, positionAbsolute, onExited, classObject, }) => {
    const onClickPopoverPanel = (event) => {
        event.stopPropagation();
    };
    const onAnimationEnd = (event) => {
        if (isClosing && event.target === event.currentTarget) {
            onExited === null || onExited === void 0 ? void 0 : onExited();
        }
    };
    return (React.createElement("div", { className: css(styles.container, positionAbsolute && styles.containerAbsolute, isClosing && styles.containerClosing, classObject), style: { top, left, transformOrigin: `${arrowLeft + 34}px 0` }, onAnimationEnd: onAnimationEnd },
        React.createElement("div", { className: css(styles.arrow), style: { left: arrowLeft } },
            React.createElement(HomeDailyLessonPopoverArrowIcon, null)),
        React.createElement("div", { className: css(styles.panel), onClick: onClickPopoverPanel },
            React.createElement("div", { className: css(styles.contents) },
                React.createElement(DailyLessonLockIcon, { classObject: styles.icon }),
                React.createElement("div", { className: css(styles.caption) },
                    React.createElement("p", { className: css(styles.title) }, "\u524D\u306E\u30EC\u30C3\u30B9\u30F3\u304C\u5B8C\u4E86\u3059\u308B\u3068AI\u304C\u9078\u3093\u3067\u304A\u5C4A\u3051\u3057\u307E\u3059\uFF01"))),
            React.createElement("div", { className: css(styles.lockedButton) }, "\u30ED\u30C3\u30AF\u4E2D"))));
};
const styles = StyleSheet.create({
    container: {
        position: 'fixed',
        width: 340,
        minWidth: 340,
        pointerEvents: 'none',
        filter: 'drop-shadow(rgba(118, 137, 162, 0.15) 0px 0px 20px)',
        animationName: {
            '0%': { opacity: 0, transform: 'scale(0.5)' },
            '55%': { opacity: 1, transform: 'scale(1.04)' },
            '100%': { opacity: 1, transform: 'scale(1)' },
        },
        animationDuration: '0.4s',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'both',
    },
    containerAbsolute: {
        position: 'absolute',
    },
    containerClosing: {
        animationName: {
            '0%': { opacity: 1, transform: 'scale(1)' },
            '100%': { opacity: 0, transform: 'scale(0.5)' },
        },
        animationDuration: '0.2s',
        animationTimingFunction: 'ease-in',
    },
    arrow: {
        position: 'absolute',
        top: 2,
        width: 68,
        height: 36,
        lineHeight: 0,
        pointerEvents: 'none',
    },
    panel: {
        position: 'relative',
        marginTop: 18,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 10,
        padding: 16,
        borderRadius: 20,
        backgroundColor: Colors.White,
        pointerEvents: 'auto',
    },
    contents: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: 8,
        minWidth: 0,
    },
    icon: {
        flexShrink: 0,
    },
    caption: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0,
        gap: 2,
    },
    title: {
        margin: 0,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: 1.4,
        letterSpacing: 0.56,
        color: Colors.GrayDarkest,
        whiteSpace: 'normal',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
    lockedButton: {
        alignSelf: 'stretch',
        height: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 1.6,
        letterSpacing: 1.28,
        color: Colors.White,
        borderRadius: 24,
        backgroundColor: Colors.BackgroundGrayD,
        cursor: 'default',
    },
});
